<template>
  <div>
    <div ref="canvasWrapper" class="canvas">
      <canvas ref="canvas"></canvas>
      <vue-qr ref="qr" :text="qr" :size="100" :margin="5"/>
    </div>
    <!-- 生成的海报 -->
    <van-dialog v-model="showH5Img" getContainer="body" :show-confirm-button="!!isPlus" confirm-button-text="分享" show-cancel-button cancel-button-text="关闭" @confirm="shareToOther">
      <img v-if="shareImg" :src="shareImg" style="display: block;width: 70vw; margin: 20px auto 0;" />
    </van-dialog>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import { getImageMainColor } from '@/utils/get-image-main-color.js'
import { mapState } from 'vuex'
const text = {
  1: '——我的新歌上线啦，快速围观！',
  2: '——听歌时间到，快来！',
  3: '——新歌速递，就是现在！',
  4: '——你与我的新歌，就差这个二维码的距离了',
  5: '——我出新歌了，你想听吗？'
}
// const color = {
//   1: ['#ccfbff', '#ef96c5'],
//   2: ['#ead6ee', '#a0f1ea'],
//   3: ['#eebd89', '#d13abd'],
//   4: ['#f9957f', '#f2f5d0'],
//   5: ['#eae5c9', '#6cc6cb'],
//   6: ['#ef33b1', '#f6e6bc'],
//   7: ['#9fa5d5', '#e8f5c8'],
//   8: ['#c973ff', '#aebaf8'],
//   9: ['#0c7bb3', '#f2bae8']
// }
export default {
  name: 'MrShare',
  components: { vueQr },
  props: {
    music: {
      type: Object
    }
  },
  data() {
    return {
      cvs: null,
      context: null,
      showH5Img: false,
      qr: '', // 二维码地址
      shareImg: '' // base64图片
    }
  },
  computed: {
    formatMusic() {
      let music = {}
      if (this.music.album) {
        // 详情接口
        music = { ...this.music.album, picsrc: this.music.album.cover }
      } else {
        // 列表或单曲详情接口
        music = { ...this.music, album_name: this.music.album_name || this.music.music_name }
      }
      return music
    },
    ...mapState(['isPlus'])
  },
  methods: {
    async share(config) {
      try {
        this.$store.commit('TOGGLE_LOADING', true)
        let url = /h5\.kkkmusic\.com/.test(location.origin) ? `http://x5.kkkmusic.com/activity.html#/?km_aid=${this.formatMusic.km_aid}` : `http://x5.musickkk.com/activity.html#/?km_aid=${this.formatMusic.km_aid}`
        this.qr = (config && config.km_mid) ? `${url}&km_mid=${config.km_mid}` : url
        this.cvs = this.$refs.canvas
        let res = await getImageMainColor(this.formatMusic.picsrc)
        await this.draw(res, config)

        this.shareImg = this.cvs.toDataURL('image/jpeg')
        this.showH5Img = true
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    shareToOther() {
      window.uni.postMessage({
        data: {
          type: 'share',
          img: this.shareImg
        }
      })
    },
    draw(bgc, config) {
      return new Promise((resolve, reject) => {
        let img = new Image()
        let w = document.documentElement.clientWidth
        let h = document.documentElement.clientHeight
        img.onload = () => {
          // 设置canvas尺寸
          let devicePixelRatio = window.devicePixelRatio
          this.cvs.width = w *devicePixelRatio
          this.cvs.height = h *devicePixelRatio
          this.cvs.style.width = w + 'px'
          this.cvs.style.height = h + 'px'
          this.context = this.cvs.getContext('2d')
          this.context.setTransform(devicePixelRatio, 0 , 0, devicePixelRatio, 0, 0)
          this.context.drawImage(img, 0 ,0, img.width, img.height, 0, 0, w, w)
          let lingrad = this.context.createLinearGradient(0, 0, 0, h)
          lingrad.addColorStop(0, `rgba(${bgc.r}, ${bgc.g}, ${bgc.b}, 0)`)
          lingrad.addColorStop(0.5, `rgba(${bgc.r}, ${bgc.g}, ${bgc.b}, 1)`)
          this.context.fillStyle = lingrad
          this.context.fillRect(0, 0, w, w)
          this.context.fillStyle = `rgb(${bgc.r}, ${bgc.g}, ${bgc.b})`
          this.context.fillRect(0, w - 3, w, h - w + 3 )
          // 绘制专辑名称
          config.album_type!=='single' && this.drawText({ x: 15, y: w-25, font: 16, txt: (config && config.km_mid && config.album_type!=='single' && '专辑：' || '') + this.formatMusic.album_name })
          config.album_type === 'single' && this.drawText({ x: 15, y: w-25, font: 16, txt: this.formatMusic.music_name })
          if ((config && config.km_mid) || (config.album_type === 'single')) {
            // 绘制专辑单首歌曲 、 绘制表演者
            config && config.km_mid && config.album_type!=='single' && this.drawText({ x: 35, y: w, font: 14, txt: config.music_name })
            this.drawText({ x: 35, y: w + 20, font: 12, txt: '表演：'+ config.singer })
            this.drawText({ x: 35, y: w + 40, font: 12, txt: '作曲：'+ config.composer })
            this.drawText({ x: 35, y: w + 60, font: 12, txt: '作词：'+ config.writer })
          } else {
            this.drawText({ x: 35, y: w + 20, font: 12, txt: this.formatMusic.star })
          }
          this.drawText({ x: w-10, y: w + 80, font: 12, txt: text[Math.floor(Math.random() * 5) + 1], textAlign: 'right' })
          this.drawText({ x: w/2, y: h-30, font: 12, txt: '(长按图片识别二维码)', textAlign: 'center' })
          // 添加二维码图片
          let qrImg = this.$refs.canvasWrapper.querySelector('img')
          this.context.drawImage(qrImg, 0, 0, qrImg.width, qrImg.height, (w - qrImg.width) / 2, (h - qrImg.height - 50), qrImg.width, qrImg.height)
          resolve()
          img.onload = null
        }
        img.onerror = (error) => {
          reject(error)
          img.onerror = null
        }
        img.crossOrigin="anonymous"
        img.src = this.formatMusic.picsrc
      })
    },
    drawText({ ...config }) {
      // 设置字体
      this.context.font = `${config.font}px bold 黑体`
      // 设置颜色
      this.context.fillStyle = config.color || '#fff'
      // 设置对齐方式
      this.context.textAlign = config.textAlign || 'left';
      // 绘制文字
      this.context.fillText(config.txt, config.x, config.y)
      // this.context.fillText(text[Math.floor(Math.random() * 5) + 1], w - 10, (w + 72))
    }
  }
}
</script>

<style lang="scss" scoped>
.canvas{
  position: fixed;
  bottom: -999px;
  left: -999px;
  z-index: -999;
}
</style>
